/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Recent traffic window
 */
export const Window = {
  TwentyFourh: "24h",
  Sevend: "7d",
} as const;
/**
 * Recent traffic window
 */
export type Window = ClosedEnum<typeof Window>;

/**
 * Provide exactly one of mcp_server_id or meta_mcp_server_id, and a recent window.
 */
export type GetMcpNetworkTrafficPayload = {
  /**
   * MCP server ID (mutually exclusive with meta_mcp_server_id)
   */
  mcpServerId?: string | undefined;
  /**
   * Gateway ID (mutually exclusive with mcp_server_id)
   */
  metaMcpServerId?: string | undefined;
  /**
   * Recent traffic window
   */
  window: Window;
};

/** @internal */
export const Window$outboundSchema: z.ZodMiniEnum<typeof Window> = z.enum(
  Window,
);

/** @internal */
export type GetMcpNetworkTrafficPayload$Outbound = {
  mcp_server_id?: string | undefined;
  meta_mcp_server_id?: string | undefined;
  window: string;
};

/** @internal */
export const GetMcpNetworkTrafficPayload$outboundSchema: z.ZodMiniType<
  GetMcpNetworkTrafficPayload$Outbound,
  GetMcpNetworkTrafficPayload
> = z.pipe(
  z.object({
    mcpServerId: z.optional(z.string()),
    metaMcpServerId: z.optional(z.string()),
    window: Window$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      metaMcpServerId: "meta_mcp_server_id",
    });
  }),
);

export function getMcpNetworkTrafficPayloadToJSON(
  getMcpNetworkTrafficPayload: GetMcpNetworkTrafficPayload,
): string {
  return JSON.stringify(
    GetMcpNetworkTrafficPayload$outboundSchema.parse(
      getMcpNetworkTrafficPayload,
    ),
  );
}
